import { useTimezone } from '@app/core/hooks/useTimezone';
import { useTzFormat } from '@app/core/hooks/useTzFormat';
import { LocaleTime } from '@mi-front/ui';
import React from 'react';

interface Props extends React.ComponentProps<typeof LocaleTime> {
  tz?: string;
  showSeconds?: boolean;
  hour12?: boolean;
}

/** Locale-aware time; title tooltip uses the active (or overridden) timezone. */
export function LTime(p: Props) {
  const { value, tz: passedTz, showSeconds = false, hour12 = false, ...rest } = p;
  const contextTz = useTimezone();
  const formatTz = useTzFormat();
  const tz = passedTz || contextTz;

  return (
    <span title={formatTz(value, 'LLLL (Z)', passedTz)}>
      <LocaleTime
        timeZone={tz}
        value={value}
        second={showSeconds ? '2-digit' : undefined}
        hour12={hour12}
        {...rest}
      />
    </span>
  );
}
